import React, { ChangeEventHandler } from 'react'
import { useCallback, useState, useRef, useEffect, useMemo, RefObject } from 'react'
import { NavBar } from '../../components/layout/NavBar'
import { Services } from '@/services/services'
import { useNavigate, useParams } from 'react-router-dom'

import './Tag.module.css'
import { QR } from '@/services/model/qr'
import { MainLayout } from '@/components/layout/MainLayout'


interface Dict {
  id: string
  label: string
} 

export const QRTag = ({services}: {services: Services}) => {
  const navigate = useNavigate();
  let tid = useParams().id
  // const [qr, setQr] = useState<QR>()

  useEffect(() => {
    fetch(`/api/schema/qr/byid/${tid}`).then((resp) => {
      return resp.json()
    }).then((data) => {
      // setQr(data)
      navigate(`/communal/machine/${data.machineId}`)
    }, () => {
      navigate(`/qr/activate/${tid}`)
    });
  }, [tid])

  // return (<>
  //   <NavBar services={services} />
  //   <div className='qr-tag content-body'>
  //     {qr === undefined ? 'checking...' : `qr code is activated for ${qr.company.name} and machine with IMEI ${qr.machine.imei}`}
  //   </div>
  // </>
  // );
  return <div className='spinner'></div>
};
